import { type AxiosResponse } from 'axios';

import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';
import { type DuplicatedOrderStatus } from '~/types/Order';

/**
 * Retrieves the status of a duplicated order.
 *
 * This function makes a server request to obtain the current status of an order
 * that has been duplicated. It requires the IDs of both the original and the
 * cloned order.
 *
 * @param {string} originalOrderId - The ID of the original order.
 * @param {string} clonedOrderId - The ID of the duplicated (cloned) order.
 *
 * @return {Promise<AxiosResponse<DuplicatedOrderStatus>>} - A promise resolving to the server response,
 * containing the status of the duplicated order.
 */
export const getOrderStatus = (
  originalOrderId: string,
  clonedOrderId: string,
): Promise<AxiosResponse<DuplicatedOrderStatus>> =>
  ordersAPI.request({
    method: 'GET',
    url: `${WEB_ORDERS_API}/${originalOrderId}/clone/${clonedOrderId}`,
  });
